import React, { createRef, useCallback, useEffect, useRef } from 'react';
import { Flex, Link } from '@chakra-ui/react';
import { useHistory, useLocation } from 'react-router';
import { Button, Icon, TextInput, Unform } from 'components';

import * as Styles from './styles';
import ImageLogo from '../assets/logo-daniel.svg';
import { routePaths } from 'constants/routes';
import { postVerificationCode, postResetPassword } from 'services/auth';
import { tokenValidationSchema } from 'yupSchemas/verificationCode';
import { openNotification } from 'utils/notification';

export const VerificationCode = (): JSX.Element => {
  const history = useHistory();
  const search = useLocation().search;
  const email = new URLSearchParams(search).get('email');
  const inputs = [...Array(5)];
  const refs = useRef<any[]>(inputs.map(() => createRef()));
  const [isLoading, setIsLoading] = React.useState(false);

  const handleChange = useCallback((index: number) => {
    const inputRef = refs.current[index];
    const nextInputRef = refs.current[index + 1];
    if (inputRef.current.value > 9) inputRef.current.value = '';
    if (Number(index) + 1 < inputs.length) {
      if (inputRef.current.value !== '') nextInputRef.current.focus();
    }
  }, []);

  useEffect(() => {
    refs.current[0].current.focus();
  }, []);

  const sendEmail = useCallback(async () => {
    try {
      const response = await postResetPassword({ user_recover: email as string });
      if (response.data) {
        openNotification('Email enviado', 'success');
      } else {
        openNotification('Email não cadastrado', 'error');
      }
    } catch (err) {
      openNotification('Email não cadastrado', 'error');
    }
  }, [email]);

  const handleSubmit = useCallback(async formData => {
    // const [user_recover, verification_code] = ['alan.tanaka@ubistart.com', '12345'];
    const verification_code = Object.values(formData).join('');
    try {
      setIsLoading(true);
      const response = await postVerificationCode({
        user_recover: email as string,
        verification_code,
      });
      if (response.data) {
        history.push(`${routePaths.newPassword}?email=${email}`);
      } else {
        openNotification('Token inválido', 'error');
      }
    } catch (err) {
      openNotification('Token inválido', 'error');
    } finally {
      setIsLoading(false);
    }
  }, []);
  return (
    <Flex height="100vh" alignItems="center" justifyContent="center">
      <Flex direction="column" p={12} alignItems="center" justifyContent="center">
        <Flex
          width="360px"
          alignItems="center"
          direction="column"
          background="#fff"
          p={8}
          paddingTop={'4'}
          rounded={6}
          border={'1px solid #E9EBEE'}
          boxShadow={'0px 4px 20px rgba(0,0,0,0.20);'}
        >
          <Link
            onClick={e => {
              e.preventDefault();
              history.goBack();
            }}
            my="0.5em"
            href="#"
            alignSelf="flex-start"
          >
            <Icon size={1.5} name={'arrowLeft'} color="black700" />
          </Link>
          <Styles.Logo src={ImageLogo} alt="Logo Daniel Law" />
          <Styles.Label>Digite o código de verificação</Styles.Label>
          <Unform onSubmit={handleSubmit} validationSchema={tokenValidationSchema}>
            <Flex justifyContent="center" alignItems="center" width={'100%'}>
              {inputs.map((_, id) => {
                return (
                  <TextInput
                    key={id}
                    inputRef={refs.current[id]}
                    type="number"
                    max={9}
                    color="brand.900"
                    fontWeight={700}
                    fontSize="18px"
                    name={`ssn_${id + 1}`}
                    onChange={() => handleChange(id)}
                    background="#fff"
                    width={51}
                    height={51}
                  />
                );
              })}
            </Flex>
            <Styles.Text>
              Não recebeu o email? Verifique a caixa de spam ou{' '}
              <Styles.Anchor onClick={sendEmail}>Clique aqui para reenviar o email</Styles.Anchor>.
            </Styles.Text>
            <Button type="submit" isLoading={isLoading} mt={1} fullWidth>
              Verificar
            </Button>
          </Unform>
        </Flex>
      </Flex>
    </Flex>
  );
};
